export default __webpack_public_path__ + "static/media/logout.7aacdad8.svg";